<app-dialog-container
  title="{{ 'attachments' | translate }}"
  [showCancelButton]="false"
  confirmButtonText="{{ 'close' | translate }}"
  [isValid]="true"
>
  <app-ui-attachments
    viewMode="embedded"
    addButtonIcon="add"
    addButtonText="{{ 'addAttachment' | translate }}"
    [attachments]="control"
    [editMode]="false"
    [passiveMode]="true"
  ></app-ui-attachments>
</app-dialog-container>
